<template>
  <v-card dark color="primary lighten-1" class="mx-5 mb-5" width="320">
    <v-card-subtitle>
      <slot name="title">title</slot>
    </v-card-subtitle>
    <v-card-subtitle>
      <v-row justify="center">
        <slot name="save"></slot>
      </v-row>
    </v-card-subtitle>
    <v-card-text>
      <slot name="templateText"></slot>
    </v-card-text>
    <v-card-actions>
      <v-row justify="space-around">
        <slot name="cardActions"></slot>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {};
</script>

<style>
</style>